import React from "react";
import Link from "../ui/RouterLink";
import { additionalPrimaryArtists } from "../utils/trackCredits";

function ArtistLinks({ artists, readOnly }) {
  return artists.map((artist, index) => (
    <React.Fragment key={artist.id}>
      {index > 0 && ", "}
      {readOnly ? (
        artist.name
      ) : (
        <Link className="featured-artist" to={`/artist/${artist.id}`}>
          {artist.name}
        </Link>
      )}
    </React.Fragment>
  ));
}

export default function TrackArtistCredits({ track, readOnly = false }) {
  const primaryArtists = additionalPrimaryArtists(track);
  const featuredArtists = track.featured_artists || [];
  if (!primaryArtists.length && !featuredArtists.length) return null;
  return (
    <span className="track-subtitle" style={{ display: "block" }}>
      <ArtistLinks artists={primaryArtists} readOnly={readOnly} />
      {featuredArtists.length > 0 && (
        <>
          {primaryArtists.length > 0 && " "}feat.{" "}
          <ArtistLinks artists={featuredArtists} readOnly={readOnly} />
        </>
      )}
    </span>
  );
}
